import { ApiResponse, axiosInstance } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

/**
 *
 */
export const LoginInputSchema = z.object({
  email: z.string().email({ message: 'Invalid email address!' }),
  password: z.string().min(4, {
    message: 'Password must be at least 4 characters long!',
  }),
});

export type TLoginInput = z.infer<typeof LoginInputSchema>;
export type TLoginFetch = TLoginInput;
export type TLoginResponse = ApiResponse<TLoginInput & { token: string }>;

export const login = async (data: TLoginFetch): Promise<TLoginResponse> => {
  const url = '/auth/login';

  return axiosInstance.post(url, data);
};

/**
 * Use Login React-Query Hook
 */
type UseLoginOptions = {
  mutationConfig?: MutationConfig<typeof login>;
};

export const useLogin = ({ mutationConfig }: UseLoginOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: login,
    ...restConfig,
  });
};
